module.exports = __webpack_public_path__ + "assets/img/1-1.62f11d2e.png";